import { axiosInstance } from "@/api/apiClient";
import {
  ContactsApi,
  ContactsApiUsersViewsNinjaContactsCreateBulkContactsRequest,
  ContactsApiUsersViewsNinjaContactsListContactsRequest,
  ContactsApiUsersViewsNinjaContactsRetrieveContactRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";

const api = new ContactsApi(undefined, BASE_API, axiosInstance);

export const getContacts = async (
  payload: ContactsApiUsersViewsNinjaContactsListContactsRequest
) => {
  return api.usersViewsNinjaContactsListContacts.bind(api)(payload);
};

export const retrieveContact = async (
  payload: ContactsApiUsersViewsNinjaContactsRetrieveContactRequest
) => {
  return api.usersViewsNinjaContactsRetrieveContact.bind(api)(payload);
};

export const createBulkContacts = async (
  payload: ContactsApiUsersViewsNinjaContactsCreateBulkContactsRequest
) => {
  return api.usersViewsNinjaContactsCreateBulkContacts.bind(api)(payload);
};
